export default __webpack_public_path__ + "static/media/notFound.3833f73b.jpg";